import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';

export default (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),

    /** Whether a field with the given id is rendered. */
    hasField: (fieldId: string) =>
      base.$(`[data-hook="entity-page-field-${fieldId}"]`).exists(),
  };
};
